import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Logo Column */}
        <div className="footer-section footer-logo-section">
          <img src="/Image/NSLogo2 final.png" alt="Logo" className="footer-logo" />
        </div>

        {/* Address & Contact Column */}
        <div className="footer-section footer-info">
  <b>Address :</b>
  <p>
    <b>Office 1:</b> IT-7 Building, Qubix Business Parks,
Phase 1, Hinjawadi, Pune, Maharashtra 411057
  </p>
  <p>
    <b>Office 2:</b> #501,Shanti Heights,<br />
Manish Nagar, Nagpur - 440015,
MAHARASHTRA,
 India
  </p>
          <p><b>Contact:</b> +91-8530434964,<br></br>+91-9986554887</p>
        </div>

        {/* Contact Emails */}
        <div className="footer-section">
          <h4>CONTACT</h4>
          <p>
            <b>Email:</b><br />
            <a href="mailto:support@jbjmaicloud.com" className="redirect">
            Support@Narayanisolutions.com
            </a><br />
  
          </p>
          <p>
            <b>Website:</b><br />
            <a
              href="https://narayanisolutions.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="redirect"
            >
            narayanisolutions.com
            </a>
          </p>
        </div>

        {/* Social Icons */}
        <div className="footer-section">
          <h4>Follow us</h4>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-facebook"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-twitter"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-linkedin"></i>
            </a>
            <a href="https://t.me" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-telegram"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Narayani Solutions. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
